module.exports = __webpack_public_path__ + "static/img/1.5318e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/1.png
// module id = Icca
// module chunks = 0